import React from "react";
import "./registrationLinkExpired.scss";
import { useStrings } from "../../../../hooks/useStrings";

const RegistrationLinkExpired: React.FC = () => {
  const S = useStrings();

  const reasons = [
    S.REGISTRATION_LINK_EXPIRED.REASON_CANCELLED,
    S.REGISTRATION_LINK_EXPIRED.REASON_CHECKED_IN,
    S.REGISTRATION_LINK_EXPIRED.REASON_PAST,
  ];

  return (
    <div className="reg-expired-page" data-testid="reg-expired-page">
      <div className="reg-expired-inner" data-testid="reg-expired-inner">

        <div className="reg-expired-header" data-testid="reg-expired-header">
          <div className="reg-expired-icon-box" data-testid="reg-expired-icon-box">
            <i className="bi bi-exclamation-triangle-fill reg-expired-icon" />
          </div>
          <h1 className="reg-expired-title" data-testid="reg-expired-title">
            {S.REGISTRATION_LINK_EXPIRED.TITLE}
          </h1>
          <p className="reg-expired-subtitle" data-testid="reg-expired-subtitle">
            {S.REGISTRATION_LINK_EXPIRED.SUBTITLE}
          </p>
        </div>

        <div className="reg-expired-card" data-testid="reg-expired-card">
          <h2 className="reg-expired-reasons-heading" data-testid="reg-expired-reasons-heading">
            {S.REGISTRATION_LINK_EXPIRED.REASONS_HEADING}
          </h2>
          <ul className="reg-expired-reasons-list" data-testid="reg-expired-reasons-list">
            {reasons.map((reason, index) => (
              <li
                key={index}
                className="reg-expired-reason-item"
                data-testid={`reg-expired-reason-${index}`}
              >
                <i className="bi bi-exclamation-triangle reg-expired-reason-icon" />
                <span>{reason}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="reg-expired-footer" data-testid="reg-expired-footer">
          <p className="reg-expired-footer-help">{S.REGISTRATION_LINK_EXPIRED.HELP_PROMPT}</p>
          <p className="reg-expired-footer-contact">{S.REGISTRATION_LINK_EXPIRED.HELP_TEXT}</p>
        </div>

      </div>
    </div>
  );
};

export default RegistrationLinkExpired;
